import { Versions } from '../constants/versions';
import { IExtensions } from '../resources/istatement/extensions';
import { IResult, IResultScore } from '../resources/istatement/result';
import { Score } from './score';

export interface ResultParams extends IResult {
	[key: string]: any;
}

export class Result {
	private _score?: Score | undefined;
	success?: boolean;
	completion?: boolean;
	duration?: string;
	response?: string;
	extensions?: IExtensions;

	constructor(cfg: ResultParams = {}) {
		const { score, success, duration, completion, response, extensions } = cfg;
		this.score = this.fix_score(score);
		this.success = success;
		this.duration = duration;
		this.completion = completion;
		this.response = response;
		this.extensions = extensions;
	}

	private fix_score(value: Score | IResultScore | undefined): Score | undefined {
		return value && (value instanceof Score ? value : new Score(value));
	}
	public get score(): Score | undefined {
		return this._score;
	}
	public set score(value: Score | undefined) {
		this._score = value;
	}

	asVersion(version: Versions = '1.0.3'): IResult {
		const result: Partial<IResult> = {};
		const { score, success, duration, completion, response, extensions } = this;

		result.score = score?.asVersion();
		result.success = success;
		result.duration = duration;
		result.completion = completion;
		result.response = response;
		result.extensions = extensions;

		return result;
	}

	static fromJSON(resultJSON: string): Result {
		const _result = JSON.parse(resultJSON);

		return new Result(_result);
	}
}
